export const EXPAND_ALL_STATE = "expandAll";
export const COLLAPSE_ALL_STATE = "collapseAll";
export const INITIAL_STATE = "initial";
